import compose from 'recompose/compose';
import withHandlers from 'recompose/withHandlers';
import { withModel } from 'src/client/js/view/data-providers/model';
import braintreeClient from 'braintree-web/client';
import braintreePaypal from 'braintree-web/paypal';

import { getPaymentMethodSession } from 'src/common/facades/eagle/checkout';
import { getCookies } from '../../../../../facades/eagle/helpers/cookies';
import withCountry from '../../../../hocs/withCountry';
import { localiseUrl } from '../../../../../../../common/utils/format-localised-url';
import { submitBraintreePaypalPayment } from '../../../../../../../common/facades/eagle/checkout';
import { PayPal } from '../../../Checkout/PayPal/PayPal';
import logger from 'src/logger';

const paymentMethod = 'paypal';

const enhance = compose(
  withModel,
  withCountry,
  withHandlers({
    onClick: props => () => {
      props.handlePaymentSubmission(async () => {
        try {
          const response = await getPaymentMethodSession(paymentMethod, getCookies());
          const paymentResponse = await invokePaypalFlow(response.clientToken);
          window.location = localiseUrl(props.country, `/orders/${paymentResponse.body.orderNumber}`);
        } catch (error) {
          logger.error('Error when requesting paypal session from backend', error);
          throw error;
        }
      });
    },
  }),
);

async function invokePaypalFlow(clientToken) {
  let paypalClient = null;
  try {
    const client = await braintreeClient.create({ authorization: clientToken });
    paypalClient = await braintreePaypal.create({ client });
  } catch (error) {
    logger.error('Error when initializing braintree client', error);
    return;
  }

  try {
    const paypalResult = await paypalClient.tokenize({
      flow: 'vault',
      enableBillingAddress: false,
      enableShippingAddress: false,
      displayName: 'Wonderbly',
    });
    return await submitToEagle(paypalResult);
  } catch (error) {
    if (error && error.type !== 'CUSTOMER') {
      logger.error('Error in braintree paypal flow', error);
    }
  }
}

async function submitToEagle(paymentData) {
  return await submitBraintreePaypalPayment({
    nonce: paymentData.nonce,
    details: paymentData.details
  }, getCookies());
}


export default enhance(PayPal);



// WEBPACK FOOTER //
// ./src/client/js/view/components/PaymentMethods/PaymentButton/BraintreePaypalButton/index.js